import React, { PropsWithChildren } from 'react';
import { Icon } from '../icons/Icon';
import styles from './ErrorOverlay.module.scss';

export const ErrorOverlay = ({ onClick, children }: Props) => {
    return (
        <div className={styles.container} onClick={onClick}>

            <Icon stroke='white'
                type='alert-triangle-exclamation'
                size='large' />

            {children}
        </div>
    );
};

type Props = PropsWithChildren<{
    onClick?: () => void;
}>;